// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/update_shot.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { VisionShot } from "./vision_shot_pb";
import { file_vision_shotlist_v1_vision_shot } from "./vision_shot_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/update_shot.proto.
 */
export const file_vision_shotlist_v1_update_shot: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvdXBkYXRlX3Nob3QucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEi7QMKEVVwZGF0ZVNob3RSZXF1ZXN0EkMKBnBhcmFtcxgBIAEoCzIzLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVXBkYXRlU2hvdFJlcXVlc3QuUGFyYW1zEi8KC3VwZGF0ZV9tYXNrGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzaxrhAgoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSDwoHc2hvdF9pZBgCIAEoCRITCgtzaG90X251bWJlchgDIAEoCRINCgVzY2VuZRgEIAEoCRIQCghsb2NhdGlvbhgFIAEoCRITCgtkZXNjcmlwdGlvbhgGIAEoCRIQCghjYXN0X2lkcxgHIAMoCRISCgpmcmFtZV9zaXplGAggASgJEg0KBWFuZ2xlGAkgASgJEhcKD2NhbWVyYV9tb3ZlbWVudBgKIAEoCRIRCgllcXVpcG1lbnQYCyADKAkSDQoFcHJvcHMYDCADKAkSFgoOZGlyZWN0b3Jfbm90ZXMYDSABKAkSEAoIZHBfbm90ZXMYDiABKAkSEQoJdmZ4X25vdGVzGA8gASgJEhEKCXNmeF9ub3RlcxgQIAEoCRIQCghkaWFsb2d1ZRgRIAEoCRIVCg1zaG9vdGluZ190aW1lGBIgASgJIpkBChJVcGRhdGVTaG90UmVzcG9uc2USRAoGcmVzdWx0GAEgASgLMjQucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5VcGRhdGVTaG90UmVzcG9uc2UuUmVzdWx0Gj0KBlJlc3VsdBIzCgRzaG90GAEgASgLMiUucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90YgZwcm90bzM", [file_google_protobuf_field_mask, file_vision_shotlist_v1_vision_shot]);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotRequest
 */
export type UpdateShotRequest = Message<"protos.vision.shotlist.v1.UpdateShotRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.UpdateShotRequest.Params params = 1;
   */
  params?: UpdateShotRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotRequest.
 * Use `create(UpdateShotRequestSchema)` to create a new message.
 */
export const UpdateShotRequestSchema: GenMessage<UpdateShotRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shot, 0);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotRequest.Params
 */
export type UpdateShotRequest_Params = Message<"protos.vision.shotlist.v1.UpdateShotRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string shot_id = 2;
   */
  shotId: string;

  /**
   * @generated from field: string shot_number = 3;
   */
  shotNumber: string;

  /**
   * @generated from field: string scene = 4;
   */
  scene: string;

  /**
   * @generated from field: string location = 5;
   */
  location: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: repeated string cast_ids = 7;
   */
  castIds: string[];

  /**
   * @generated from field: string frame_size = 8;
   */
  frameSize: string;

  /**
   * @generated from field: string angle = 9;
   */
  angle: string;

  /**
   * @generated from field: string camera_movement = 10;
   */
  cameraMovement: string;

  /**
   * @generated from field: repeated string equipment = 11;
   */
  equipment: string[];

  /**
   * @generated from field: repeated string props = 12;
   */
  props: string[];

  /**
   * @generated from field: string director_notes = 13;
   */
  directorNotes: string;

  /**
   * @generated from field: string dp_notes = 14;
   */
  dpNotes: string;

  /**
   * @generated from field: string vfx_notes = 15;
   */
  vfxNotes: string;

  /**
   * @generated from field: string sfx_notes = 16;
   */
  sfxNotes: string;

  /**
   * @generated from field: string dialogue = 17;
   */
  dialogue: string;

  /**
   * @generated from field: string shooting_time = 18;
   */
  shootingTime: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotRequest.Params.
 * Use `create(UpdateShotRequest_ParamsSchema)` to create a new message.
 */
export const UpdateShotRequest_ParamsSchema: GenMessage<UpdateShotRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shot, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotResponse
 */
export type UpdateShotResponse = Message<"protos.vision.shotlist.v1.UpdateShotResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.UpdateShotResponse.Result result = 1;
   */
  result?: UpdateShotResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotResponse.
 * Use `create(UpdateShotResponseSchema)` to create a new message.
 */
export const UpdateShotResponseSchema: GenMessage<UpdateShotResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shot, 1);

/**
 * @generated from message protos.vision.shotlist.v1.UpdateShotResponse.Result
 */
export type UpdateShotResponse_Result = Message<"protos.vision.shotlist.v1.UpdateShotResponse.Result"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShot shot = 1;
   */
  shot?: VisionShot | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.UpdateShotResponse.Result.
 * Use `create(UpdateShotResponse_ResultSchema)` to create a new message.
 */
export const UpdateShotResponse_ResultSchema: GenMessage<UpdateShotResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_update_shot, 1, 0);

